export default function () {
    new Swiper(".focus-areas-swiper", {
        spaceBetween: 24,
        autoHeight: true,
        loop:true,
        slidesPerView: 1,
        navigation: {
            nextEl: ".focus-areas-swiper-navigation-button.next",
            prevEl: ".focus-areas-swiper-navigation-button.prev",
        },
    });
}

{/* <script src="https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js"></script>
<script>
	var swiper = new Swiper(".focus-areas-swiper", {
        navigation: {
        nextEl: "focus-areas-swiper-navigation.swiper-button-next",
        prevEl: "focus-areas-swiper-navigation.swiper-button-prev",
},
spaceBetween: "30px"
});
</script> */}